import * as React from 'react';
export const SvgBlank = (props) => {
    return React.createElement("svg", { viewBox: '0 0 16 16', ...props });
};
export default SvgBlank;
